import { sellerConstants } from '../../../_constants/seller.constants';
import { sellerAdminService } from '../../../_services';
import { sellerAdminActions } from './sellerAdmin.actions';

export const AddSellerAdminAction = {
    addData
};

function addData(data) {

    return dispatch => {
        dispatch(request());
        sellerAdminService.addSellerAdmin(data)
            .then(
                response => {
                    dispatch(sellerAdminActions.getSellerAdmins(data.seller_id))
                    dispatch(success(response));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: sellerConstants.REQUEST_ADD_SELLER_ADMIN } }
    function success(data) { return { type: sellerConstants.ADD_SELLER_ADMIN_SUCCESS, data } }
    function failure(error) { return { type: sellerConstants.ADD_SELLER_ADMIN_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/sellers/sellerAdmin/addSellerAdmin.actions.js